<style lang="less">
  @import '../styles/menu.less';
  @import '../../../../assets/icon/menu/iconfont.css';
</style>

<template>
  <Menu ref="sideMenu"
        class="sidebarMenu"
        :active-name="activeName"
        :open-names="openNames"
        :theme="menuTheme"
        width="auto"
        @on-select="changeMenu"
        @on-open-change="changeOpen">
    <template v-for="item in menuList">
      <!--<Submenu :name="item.name" :key="item.name">-->
        <!--<template slot="title">-->
          <!--<Icon :type="item.icon" :size="iconSize"></Icon>-->
          <!--<span class="layout-text">{{ itemTitle(item) }}</span>-->
        <!--</template>-->
        <!--<template v-for="child in item.children">-->
          <!--<menu-item :name="child.name" :key="'menuitem' + child.name">-->
            <!--<Icon :type="child.icon" :size="iconSize" :key="'icon' + child.name"></Icon>-->
            <!--<span class="layout-text" :key="'title' + child.name">{{ itemTitle(child) }}</span>-->
          <!--</menu-item>-->
        <!--</template>-->
      <!--</Submenu>-->
        <template slot="title">
            <Icon :type="item.icon"  :size="iconSize" :key="item.name"></Icon>
            <span  style="margin: 10px 0" class="layout-text" :key="item.name">{{ itemTitle(item) }}</span>
        </template>
        <template v-for="child in item.children">
          <menu-item :name="child.name" :key="'menuitem' + child.name">
            <Icon :type="child.icon"  :size="iconSize" :key="'icon' + child.name"></Icon>
            <span class="layout-text" :key="'title' + child.name">{{ itemTitle(child) }}</span>
          </menu-item>
        </template>
    </template>
  </Menu>
</template>

<script>
  export default {
    name: 'sidebarMenu',
    props: {
      menuList: Array,
      iconSize: Number,
      menuTheme: {
        type: String,
        default: 'dark'
      },
      openNames: {
        type: Array
      }
    },
    methods: {
      changeMenu (active) {
        this.$emit('on-change', active)
      },
      changeOpen (openNames) {
        this.$emit('on-open-change', openNames)
      },
      itemTitle (item) {
        if (typeof item.title === 'object') {
          return this.$t(item.title.i18n)
        } else {
          return item.title
        }
      }
    },
    updated () {
      this.$nextTick(() => {
        if (this.$refs.sideMenu) {
          this.$refs.sideMenu.updateOpened()
          this.$refs.sideMenu.updateActiveName()
        }
      })
    },
    computed: {
      activeName () {
        if (this.$route.meta && this.$route.meta.activeName) {
          return this.$route.meta.activeName
        } else {
          return this.$route.name
        }
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/views/components/shrinkable-menu/components/sidebarMenu.vue